import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { useTheme } from '../context/ThemeContext';
import logoDark from '../assets/logo-dark.png';
import logoLight from '../assets/logo-light.png';

const Footer = () => {
    const { theme } = useTheme();
    const logo = theme === 'light' ? logoLight : logoDark;
    return (
        <footer className="footer-container">
            <div className="footer-content">
                <div className="footer-left">
                    <Link to="/" className="footer-logo-link">
                        <img src={logo} alt="RiyaMaga" className="footer-logo-img" />
                    </Link>
                    <span className="footer-copyright">© {new Date().getFullYear()}</span>
                </div>

                <nav className="footer-nav">
                    <Link to="/buy" className="footer-link">Vehicles</Link>
                    <Link to="/parts" className="footer-link">Parts</Link>
                    <Link to="/service-stations" className="footer-link">Services</Link>
                    <Link to="/about" className="footer-link">About</Link>
                    <Link to="/contact" className="footer-link">Contact</Link>
                    <Link to="/privacy" className="footer-link">Privacy</Link>
                    <Link to="/terms" className="footer-link">Terms</Link>
                </nav>
            </div>
        </footer>
    );
};

export default Footer;
